export default function StepIndicator({ step, total }) {
  const labels = ['Set up basics', 'Choose recurrence', 'Pick time slots'];
  return (
    <div
      className="step-indicator"
      style={{ marginBottom: 36 }}
      role="group"
      aria-label={`Step ${step + 1} of ${total}: ${labels[step] || ''}`}
    >
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={`step-dot${i === step ? ' active' : i < step ? ' done' : ''}`}
          aria-hidden="true"
        />
      ))}
      <span className="sr-only">Step {step + 1} of {total}: {labels[step]}</span>
    </div>
  );
}
